import React from "react"
import Layout from "../components/layout"
import { CHECKOUT_PAGE_URL } from "../helpers/constants"
import styled from "styled-components"

const StyledIFrame = styled.iframe`
  width: 100%;
  height: 100vh;
  overflow: scroll;
  overflow-x: hidden;
  border: none;
  -ms-overflow-style: none;
  scrollbar-width: none;
  & ::-webkit-scrollbar {
    display: none;
  }
`

const Checkout = props => {
  return (
    <Layout {...props} minHeight="10rem" showFooterInMobile={false}>
    <StyledIFrame src={`${CHECKOUT_PAGE_URL}`} />
    </Layout>
  )
}

export default Checkout
